import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { Menu } from '@headlessui/react';
import { DefaultPopper, SvgIcon, SvgIconType } from '@integration-app/react';
import clsx from 'clsx';
import classes from './FieldTypeSelector.module.css';
import useEventStopPropagation from '../../../hooks/useEventStopPropagation';
import { useSchemaBuilderContext } from '../../SchemaContext';
const VALUE_TYPE_LABEL = {
    string: 'string',
    number: 'number',
    integer: 'integer',
    boolean: 'boolean',
    object: 'object',
    array: 'list',
    null: 'any',
    undefined: 'any',
};
export function FieldTypeSelector({ type, onTypeChange, }) {
    const { readOnly } = useSchemaBuilderContext();
    const refElement = useRef(null);
    const [typeValue, setValue] = useState(type);
    if (!onTypeChange || readOnly) {
        return (_jsx("span", { className: clsx(classes.fieldType, classes[`fieldType__${typeValue}`], classes.readOnly), children: VALUE_TYPE_LABEL[typeValue] }));
    }
    const valueTypes = [
        'string',
        'number',
        'integer',
        'boolean',
        'object',
        'array',
    ];
    return (_jsx(Menu, { children: ({ open, close }) => (_jsx(_Fragment, { children: _jsx(DefaultPopper, { placement: 'bottom', isOpen: open, refElement: refElement, onClickOutside: close, className: classes.defaultMenu, triggerNode: _jsxs(Menu.Button, { className: clsx(classes.fieldType, classes[`fieldType__${typeValue}`]), as: 'button', ref: refElement, children: [VALUE_TYPE_LABEL[typeValue], ' ', _jsx(SvgIcon, { type: SvgIconType.ChevronDown })] }), children: _jsx(Menu.Items, { className: classes.defaultMenuList, children: valueTypes.map((type) => (_jsx(Menu.Item, { children: _jsxs("button", { className: clsx(classes.defaultMenuItem, type === typeValue && classes.defaultMenuItemActive), disabled: type === typeValue, onClick: useEventStopPropagation(() => {
                                setValue(type);
                                onTypeChange(type);
                                close();
                            }), children: [_jsx(SvgIcon, { type: SvgIconType[`SchemaType_${type}`] }), ' ', VALUE_TYPE_LABEL[type]] }) }, type))) }) }) })) }));
}
//# sourceMappingURL=FieldTypeSelector.js.map